export default __webpack_public_path__ + "static/media/country.e8f3a555.jpg";